import { RegistrationType } from 'app/features/manual-input-registration/models/registration-type';
import { TimeRegistrationCode } from 'app/features/scan-flow/models/time-registration-code';
import { Activity, defaultActivity } from 'app/shared/features/activity-selector/models/activity';

export interface TimeRegistrationDefinition {
    name: string;
    id: string;
    activity: Activity | undefined;
    registrationType: RegistrationType;
    code: TimeRegistrationCode | undefined;
}

export function endBreakActivityToTimeRegistrationDefinition(activity: Activity): TimeRegistrationDefinition {
    return {
        activity,
        name: activity.name,
        id: `end-break-${activity.number}`,
        registrationType: RegistrationType.EndPause,
        code: undefined,
    };
}

export const loginRegistrationDefinition: TimeRegistrationDefinition = {
    registrationType: RegistrationType.Login,
    id: 'login',
    activity: undefined,
    name: 'LOGIN.TITLE.DEFAULT',
    code: 'login',
};
export const logoutRegistrationDefinition: TimeRegistrationDefinition = {
    registrationType: RegistrationType.Logout,
    id: 'logout',
    activity: undefined,
    name: 'GENERAL.TITLE.LOGOUT',
    code: 'logout',
};
export const startBreakRegistrationDefinition: TimeRegistrationDefinition = {
    registrationType: RegistrationType.StartPause,
    id: 'startbreak',
    activity: undefined,
    name: 'GENERAL.TITLE.START_BREAK',
    code: 'startbreak',
};

export const createTimeRegistrationActivity = (activityName: string | undefined): Activity => ({
    ...defaultActivity(),
    name: activityName ?? '',
});
